const nav = require('../utils/nav').Utils;
const auth = require('../utils/auth').Auth;

exports.UserService = {
    getMe: function(callback) {
        let xmlhttp = new XMLHttpRequest();
        xmlhttp.onreadystatechange = function () {
            if (xmlhttp.readyState === 4) {
                if (xmlhttp.status === 200) {
                    callback(null, JSON.parse(xmlhttp.responseText));
                } else if (xmlhttp.status === 403) {
                    nav.authorizationError();
                } else {
                    callback(xmlhttp.status);
                }
            }
        };
        xmlhttp.open('GET', auth.getFullUrl('me'), true);
        xmlhttp.setRequestHeader('Content-type', 'application/json');
        auth.addAuthHeader(xmlhttp);
        xmlhttp.send();
    },

    put: function(user, callback) {
        let xmlhttp = new XMLHttpRequest();
        xmlhttp.onreadystatechange = function() {
            if (xmlhttp.readyState === 4) {
                if (xmlhttp.status === 200) {
                    callback();
                }
                else if (xmlhttp.status === 403) {
                    nav.authorizationError();
                } else {
                    callback(xmlhttp.status);
                }
            }
        };
        xmlhttp.open('PUT', auth.getFullUrl('user'), true);
        xmlhttp.setRequestHeader('Content-type', 'application/json');
        auth.addAuthHeader(xmlhttp);
        xmlhttp.send(JSON.stringify(user));
    }
}